export default __webpack_public_path__ + "static/media/HIW-val-1.b0049e03.webp";